import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.views.login.label.title',
    defaultMessage: 'Welcome Back',
    description: 'Login page heading text',
  },
  fieldEmailAndUsernamePlaceholder: {
    id: 'portal.views.login.field.emailAndUsername.placeholder',
    defaultMessage: 'Email or Username',
    description: 'Login field placeholder text',
  },
  password: {
    id: 'portal.views.login.field.password.placeholder',
    defaultMessage: 'Password',
    description: 'Placeholder for password input',
  },
  forgotPassword: {
    id: 'portal.views.login.link.forgotPassword',
    defaultMessage: 'Forgot password?',
    description: 'Forgot password link text',
  },
  noAccount: {
    id: 'portal.views.login.text.noAccount',
    defaultMessage: 'Don\'t have an account?',
    description: 'Prompt for users without an account',
  },
  signUp: {
    id: 'portal.views.login.link.signup',
    defaultMessage: 'Sign Up',
    description: 'Sign up link text',
  },
  resetPassword: {
    id: 'portal.views.login.link.resetPassword',
    defaultMessage: 'reset your password',
    description: 'Reset your password link text',
  },
  passwordRequirementsChanged: {
    id: 'portal.views.login.section.passwordRequirementsChanged',
    defaultMessage: 'We recently changed our password requirements',
    description: 'Password requirements changed heading',
  },
  nonCompliantPassword: {
    id: 'portal.views.login.section.nonCompliantPassword',
    defaultMessage: 'Your current password does not meet the new security requirements. '
      + 'We just sent a password-reset message to the email address associated with this account. '
      + 'Thank you for helping us keep your data safe.',
    description: 'Non compliant password message',
  },
  tooManyAttempts: {
    id: 'portal.views.login.section.tooManyAttempts',
    defaultMessage: 'Too many failed login attempts. Try again later.',
    description: 'Too many failed login attempts message',
  },
  contactSupport: {
    id: 'portal.views.login.link.contactSupport',
    defaultMessage: 'contact {platformName} support',
    description: 'Contact platform support link text',
  },
  activateAccount: {
    id: 'portal.views.login.section.activateAccount',
    defaultMessage: 'In order to sign in, you need to activate your account.',
    description: 'Activate account message',
  },
  activationLinkSent: {
    id: 'portal.views.login.section.activationLinkSent',
    defaultMessage: 'We just sent an activation link to your <strong>{email}</strong>. '
      + 'If you do not receive an email, check your spam folders or',
    description: 'Activation link sent message',
  },
  allowedDomainLogin: {
    id: 'portal.views.login.section.allowedDomainLogin',
    defaultMessage: 'As {allowedDomain} user, You must login with your {allowedDomain} {provider} account.',
    description: 'Allowed domain login error message',
  },
  fillFields: {
    id: 'portal.views.login.section.fillFields',
    defaultMessage: 'Please fill in the fields below.',
    description: 'Please fill in the fields below message',
  },
  clickHereToReset: {
    id: 'portal.views.login.link.clickHereToReset',
    defaultMessage: 'click here to reset it.',
    description: 'Click here to reset password message',
  },
  incorrectCredentialsAttempts: {
    id: 'portal.views.login.section.incorrectCredentialsAttempts',
    defaultMessage: 'The username, email or password you entered is incorrect. '
      + 'You have {remainingAttempts} more sign in attempts before your account is temporarily locked.',
    description: 'Incorrect credentials with attempts left message',
  },
  forgotPasswordPrompt: {
    id: 'portal.views.login.section.forgotPasswordPrompt',
    defaultMessage: 'If you\'ve forgotten your password,',
    description: 'Forgot password prompt',
  },
  accountLocked: {
    id: 'portal.views.login.section.accountLocked',
    defaultMessage: 'To protect your account, it\'s been temporarily locked. Try again in 30 minutes.',
    description: 'Account locked message',
  },
  resetBeforeRetry: {
    id: 'portal.views.login.section.resetBeforeRetry',
    defaultMessage: 'To be on the safe side, you can',
    description: 'Reset before retry message',
  },
  incorrectCredentials: {
    id: 'portal.views.login.section.incorrectCredentials',
    defaultMessage: 'The username, email, or password you entered is incorrect. Please try again.',
    description: 'Incorrect credentials message',
  },
  incorrectCredentialsOrReset: {
    id: 'portal.views.login.section.incorrectCredentialsOrReset',
    defaultMessage: 'The username, email, or password you entered is incorrect. Please try again or',
    description: 'Incorrect credentials or reset message',
  },
  vulnerablePassword: {
    id: 'portal.views.login.section.vulnerablePassword',
    defaultMessage: 'Our system detected that your password is vulnerable. We recommend you change it so that your account stays secure.',
    description: 'Vulnerable password message',
  },
  vulnerablePasswordChange: {
    id: 'portal.views.login.section.vulnerablePasswordChange',
    defaultMessage: 'Our system detected that your password is vulnerable. Change your password so that your account stays secure.',
    description: 'Vulnerable password change message',
  },
  tpaAuthFailure: {
    id: 'portal.views.login.section.tpaAuthFailure',
    defaultMessage: 'We are sorry, you are not authorized to access {siteName} via this channel. Please contact your learning administrator or manager in order to access {siteName}.',
    description: 'TPA authentication failure message',
  },
  errorDetails: {
    id: 'portal.views.login.label.errorDetails',
    defaultMessage: 'Error Details:',
    description: 'Error details label',
  },
  genericError: {
    id: 'portal.views.login.section.genericError',
    defaultMessage: 'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Generic error message',
  },
  couldNotSignIn: {
    id: 'portal.views.login.label.couldNotSignIn',
    defaultMessage: 'We couldn\'t sign you in.',
    description: 'Notification header title',
  },
  enterEmailOrUsername: {
    id: 'portal.views.login.validation.enterEmailOrUsername',
    defaultMessage: 'Enter your username or email',
    description: 'Validation: empty username/email',
  },
  emailOrUsernameMinLength: {
    id: 'portal.views.login.validation.emailOrUsernameMinLength',
    defaultMessage: 'Username or email must have at least 2 characters',
    description: 'Validation: username/email min length',
  },
  enterPassword: {
    id: 'portal.views.login.validation.enterPassword',
    defaultMessage: 'Enter your password',
    description: 'Validation: empty password',
  },
  invalidResetLinkTitle: {
    id: 'portal.views.resetPassword.error.invalidResetLink.title',
    defaultMessage: 'Invalid Password Reset Link',
    description: 'Title for invalid password reset link',
  },
  invalidResetLinkText: {
    id: 'portal.views.resetPassword.error.invalidResetLink.text',
    defaultMessage: 'This password reset link is invalid. It may have been used already. To reset your password, select Forgot password.',
    description: 'Text for invalid password reset link',
  },
  successTitle: {
    id: 'portal.views.resetPassword.success.title',
    defaultMessage: 'Password Reset Complete',
    description: 'Title for reset password success notification',
  },
  successDescription: {
    id: 'portal.views.resetPassword.success.description',
    defaultMessage: 'Your password has been reset. Sign in to your account.',
    description: 'Description for successful password reset',
  },
  forgotPasswordSuccessTitle: {
    id: 'portal.views.forgotPassword.success.title',
    defaultMessage: 'Important',
    description: 'Title for forgot password success notification',
  },
  forgotPasswordSuccessDescription: {
    id: 'portal.views.forgotPassword.success.description',
    defaultMessage: 'Reset password initiated. Kindly check your email address and follow instructions.',
    description: 'Description for forgot password success notification',
  },
  resetPasswordNotificationMessage: {
    id: 'portal.views.login.resetPassword.notification',
    defaultMessage: 'We’ve migrated to a new platform. If you can’t sign in, please reset your password to access your account.',
    description: 'A message urging users to reset their password due to a system migration',
  },
});

export default messages;
